var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
export var DefaultLink = function (props) {
  return React.createElement("a", __assign({}, props), props.children);
};
export var defaultNavigate = function (to, options) {
  if (typeof window !== 'undefined') {
    window.location.href = to;
  }
};
export var LinkContext = React.createContext({
  Link: DefaultLink,
  navigate: defaultNavigate
});
export var LinkProvider = LinkContext.Provider;